export default {
  Common: {
    ListAsset: "Danh sách tài sản điều chuyển",
    SearchType: "Tìm tài sản theo",
    Employee: "Nhân viên",
    Department: "Phòng ban",
    Location: "Vị trí tài sản",
    "Asset-code-name": "Mã/Tên tài sản",
    SelectAllAsset: "Chọn toàn bộ 5 tài sản",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    EmployeeUse: "Người sử dụng",
    Quantity: "Số lượng",
    LocationDetail: "Vị trí tài sản",
    AssetStatus: "Trạng thái",
    Tranfer: "Điều chuyển",
    EmployeePlaceholder: "Tìm kiếm tài sản theo tên, mã nhân viên",
    DepartmentPlaceholder: "Tìm kiếm tài sản theo tên, mã phòng ban",
    LocationPlaceholder: "Tìm kiếm tài sản theo tên, mã vị trí",
    AssetPlaceholder: "Tìm kiếm tài sản theo tên, mã tài sản",

    QuantityTransfer: "SL điều chuyển",
    Specification: "Quy cách",
    TransferType: "Loại điều chuyển",
    GeneralInformation: "Thông tin chung",
    TransferAssetLocation: "Điều chuyển vị trí tài sản",
    TransferUser: "Điều chuyển đối tượng sử dụng",
    TransferManagementUnit: "Điều chuyển đơn vị quản lý",
    Reason: "Lý do điều chuyển",
    TransferFrom: "Điều chuyển từ",
    TransferTo: "Điều chuyển đến",
    AssetTransfer: "Tài sản được điều chuyển",
    UsedOrganizationUnit: "Đơn vị sử dụng",
    ObjectUsed: "Đối tượng sử dụng",
    Representator: "Người đại diện",
    ManagementUnit: "Đơn vị quản lý",
    Manager: "Người quản lý",
    AddRow: "Thêm dòng",
    QuickSelect: "Chọn nhanh",
    AssetProperty: "Tình trạng",
    Edit: "Sửa",
    Acceptable: "Nhận tài sản",
    Unacceptable: "Từ chối",
    CancelButton: "Đóng",
    RemainQuantity: "Số lượng tồn",

    EmployeeAll: "Tất cả tài sản",
    EmployeeOwner: "Tài sản sử dụng",
    EmployeeRepresent: "Tài sản đại diện nhận",
    OrganizationUnitAll: "Tất cả tài sản",
    OrganizationUnitOwner: "Tài sản cấp cho phòng ban",
    OrganizationUnitEmployee: "Tài sản cấp cho nhân viên",
  },
  Validate: {
    NotParentFromLocation: "Chỉ được điều chuyển tài sản của vị trí tài sản ở cấp chi tiết nhất.",
    NotParentToLocation: "Tài sản chỉ được điều chuyển đến vị trí tài sản ở cấp chi tiết nhất.",
    NotParentToOrganizationUnit:
      "Tài sản chỉ được điều chuyển đến đơn vị sử dụng ở cấp chi tiết nhất.",
    NotParentToManagermentUnit:
      "Tài sản chỉ được điều chuyển đến đơn vị quản lý ở cấp chi tiết nhất.",
    NotPickTransferQuantity: "Chưa chọn vị trí tài sản để điều chuyển.",
    QuantityTransferError:
      "Số lượng điều chuyển từng dòng tích chọn đang khác với tổng số lượng điều chuyển.",
    ErrorOccurenceDateTransfer: "Ngày điều chuyển phải lớn hơn hoặc bằng ngày ##0##.",
    ErrorTotalQuantity:
      "Bạn chưa nhập số lượng điều chuyển, vui lòng nhập số lượng điều chuyển trước.",
  },
  Internal: {
    Title: "Điều chuyển nội bộ",
    TitleRight: "Điều chuyển đến",
    TransferNo: "Số biên bản",
    AllocationType: "Điều chuyển đến",
    Employee: "Nhân viên",
    Department: "Phòng ban",
    OrganizationUnit: "Đơn vị",
    ToOrganizationUnitID: "Phòng ban",
    Representative: "Người đại diện",
    ToLocationID: "Vị trí tài sản",
    TransferDate: "Ngày điều chuyển",
    Reason: "Lý do",
    Attachment: "Tệp đính kèm",
    Belong: "Trực thuộc",
  },
  External: {
    Title: "Điều chuyển đi",
    TitleRight: "Điều chuyển đến",
    TransferNo: "Số biên bản",
    FromOrganizationUnitID: "Từ đơn vị",
    DeliverID: "Người giao",
    ToOrganizationUnitID: "Đến đơn vị",
    ReceiverID: "Người nhận",
    Department: "Phòng ban",
    OrganizationUnit: "Đơn vị",

    ToLocationID: "Vị trí tài sản",
    TransferDate: "Ngày điều chuyển",
    Reason: "Lý do",
    Attachment: "Tệp đính kèm",
    Belong: "Trực thuộc",
  },

  //nnphong - popup điều chuyển 1 tài sản số lượng
  SingleTransferAssetQuantity: {
    Title: "Điều chuyển tài sản",
    TransferType: "Loại điều chuyển",
    TransferLocation: "Điều chuyển vị trí tài sản",
    TransferUser: "Điều chuyển đối tượng sử dụng",
    TransferManagementUnit: "Điều chuyển đơn vị quản lý",
    TransferInfor: "Thông tin điều chuyển",
    TallyNo: "Số biên bản",
    TransferReason: "Lý do điều chuyển",
    TransferDate: "Ngày điều chuyển",
    TransferQuantity: "Số lượng điều chuyển",
    AssetLocation: "Vị trí tài sản",
    UsingObject: "Đối tượng sử dụng",
    UsingPerson: "Người sử dụng",
    UsingOrganizationUnit: "Đơn vị sử dụng",
    Representator: "Người đại diện",
    RemainingQuantity: "Số lượng tồn",
    Quantity: "Số lượng điều chuyển",
    Employee: "Nhân viên",
    OrganizationUnit: "Phòng ban",
    Transfer: "Điều chuyển",
    TransferTo: "Điều chuyển đến",
    ManagementUnit: "Đơn vị quản lý",
    StatusAsset: "Tình trạng",
    ErrorQuantity: "Số lượng điều chuyển phải thuộc khoảng từ 1 đến ##0##",
    ErrorPurchaseDate: "Ngày điều chuyển phải lớn hơn hoặc bằng ngày mua",
    ErrorDenyPurchaseDate: "Ngày từ chối nhận tài sản không được nhỏ hơn ngày mua",
    ErrorStatus: "Chỉ được điều chuyển tài sản Chưa sử dụng hoặc Đang sử dụng",
    ErrorOccurenceDate: (value) =>
      `Tài sản đã phát sinh nghiệp vụ vào ngày <${value}>. Ngày điều chuyển phải lớn hơn hoặc bằng <${value}>.`,
    ErrorDenyOccurenceDate: "Ngày từ chối nhận tài sản không được nhỏ hơn ngày điều chuyển",
    NoQuantity: "Số lượng điều chuyển phải lớn hơn 0",
    ErrorTransferOpenForm:
      "Chỉ được điều chuyển tài sản khác các trạng thái Mất, Hủy, Thanh lý, Đang điều chuyển.",
  },
  SingleTransferAssetCode: {
    Location: "Vị trí tài sản",
    Object: "Đối tượng sử dụng",
    Employee: "Nhân viên",
    OrganizationUnit: "Phòng ban",
    Representative: "Người đại diện",
    OrganizationUnitManager: "Đơn vị quản lý",
    ManagerName: "Người quản lý",
    UsedOrganizationUnitName: "Đơn vị sử dụng",
    UsedName: "Người sử dụng",
  },
  WarrningBusiness: {
    WarningSelectedDetail: "Tài sản chọn đã có trong danh sách!",
    WarningDeleteDetail: "Không thể xóa tài sản điều chuyển!",
    WarringLocation:
      "Vị trí tài sản điều chuyển đến và Vị trí tài sản cũ của tài sản không được trùng nhau.",
    WarringUser: "Đối tượng sử dụng mới và đối tượng sử dụng cũ của tài sản không được trùng nhau.",
    WarringOrganizationManagerment:
      "Đơn vị quản lý điều chuyển đến và Đơn vị quản lý cũ của tài sản không được trùng nhau.",
    WarringManager:
      "Người quản lý điều chuyển đến và Người quản lý cũ của tài sản không được trùng nhau.",
    WarningEmployee:
      "Nhân viên điều chuyển đi và nhân viên nhận điều chuyển không được phép trùng nhau.",
    WarningOrganizationUnit:
      "Đơn vị sử dụng điều chuyển đi và đơn vị sử dụng nhận điều chuyển không được phép trùng nhau",
    WarningFromObject: "Đối tượng điều chuyển đi không được để trống",
    WarningFromManagement: "Đơn vị quản lý điều chuyển đi không được để trống",
    WarningFromLocation: "Vị trí tài sản điều chuyển đi không được để trống",
    WarningToLocation: "Vị trí tài sản điều chuyển đến không được để trống",
    WarringOrganizationParent: "Tài sản chỉ được điều chuyển đến phòng ban ở cấp chi tiết nhất.",
    WarringLocationParent:
      "Bạn chỉ được điều chuyển đến vị trí tài sản không có vị trí tài sản trực thuộc.",
    WarningEmptyRows:
      "Tồn tại những dòng bị trống trong danh sách Tài sản điều chuyển, chúng sẽ không được ghi nhận, bạn có muốn tiếp tục không?",
    WarningEmptyTransfer: "Vui lòng chọn tài sản cần điều chuyển trước.",
    WarningEmptyLocation:
      "Bạn chưa chọn vị trí tài sản cần điều chuyển, vui lòng chọn vị trí tài sản trước.",
    WarningChangeType:
      "Khi thay đổi loại điều chuyển, bạn sẽ phải nhập lại Danh sách tài sản được điều chuyển. Có tiếp tục thay đổi không?",
    WarningTransferDate: "Ngày điều chuyển phải lớn hơn hoặc bằng ngày mua.",
    WarningChangeObject:
      "Khi thay đổi đối tượng sử dụng, bạn sẽ phải nhập lại Danh sách tài sản được điều chuyển. Có tiếp tục thay đổi không?",
    WarningSelectDetail: "Chưa chọn tài sản điều chuyển.",
    QuantityWarningChangeType:
      "Khi thay đổi loại điều chuyển, danh sách Số lượng điều chuyển sẽ thay đổi. Bạn có muốn tiếp tục thay đổi không?",
    WarningTransferObject:
      "Điều chuyển đối tượng sử dụng được thực hiện với tài sản đang sử dụng. Vui lòng chọn lại tài sản.",
    WarningTransferManager:
      " Điều chuyển đơn vị quản lý được thực hiện với tài sản chưa sử dụng. Vui lòng chọn lại tài sản.",
  },
};
